"use strict";

exports.__esModule = true;
exports.default = void 0;
var _ = require(".");
/* eslint-disable no-undef */

const joinReducerCases = options => {
  const _entityName = options.localName.toUpperCase() + options.foreignName.toUpperCase();
  const _propName = options.propName ? options.propName : options.foreignName.charAt(options.foreignName.length - 1).toLowerCase() === "y" ? (0, _.capitalize)(options.localName) + (0, _.capitalize)(options.foreignName.slice(0, -1)) + "ies" : (0, _.capitalize)(options.localName) + (0, _.capitalize)(options.foreignName) + "s";
  const _localId = (0, _.capitalize)(options.localName) + "Id";
  let list, single;
  return {
    ["CREATE_" + _entityName + "_SUCCESS"]: (state, action) => {
      list = {
        ...state.list,
        data: state.list.data ? state.list.data.map(d => {
          if (d.Id === action.data[_localId]) {
            return {
              ...d,
              [_propName]: options.propType === "Object" ? action.data : [...(d[_propName] ? d[_propName] : []), action.data]
            };
          }
          return d;
        }) : []
      };
      single = {
        ...state.single,
        data: state.single.data ? {
          ...state.single.data,
          ...(state.single.data[_propName] ? {
            [_propName]: options.propType === "Object" ? action.data : [...(state.single.data[_propName] ? state.single.data[_propName] : []), action.data]
          } : {
            [_propName]: options.propType === "Object" ? action.data : [action.data]
          })
        } : null
      };
      return {
        ...state,
        list,
        single
      };
    },
    ["UPDATE_" + _entityName + "_SUCCESS"]: (state, action) => {
      list = {
        ...state.list,
        data: state.list.data ? state.list.data.map(d => {
          if (d.Id === action.data[_localId]) {
            return {
              ...d,
              [_propName]: options.propType === "Object" ? action.data : [...(d[_propName] ? d[_propName] : []), action.data]
            };
          }
          return d;
        }) : []
      };
      single = {
        ...state.single,
        data: state.single.data ? {
          ...state.single.data,
          ...(state.single.data[_propName] ? {
            [_propName]: options.propType === "Object" ? action.data : [...(d[_propName] ? d[_propName] : []), action.data]
          } : {
            [_propName]: options.propType === "Object" ? action.data : [action.data]
          })
        } : null
      };
      return {
        ...state,
        list,
        single
      };
    },
    ["DELETE_" + _entityName + "_SUCCESS"]: (state, action) => {
      list = {
        ...state.list,
        ...(state.list.data ? {
          data: state.list.data.map(d => {
            return {
              ...d,
              ...(d[_propName] ? {
                [_propName]: Array.isArray(d[_propName]) ? d[_propName].filter(r => r.Id !== action.data.Id) : []
              } : [])
            };
          })
        } : [])
      };
      single = {
        ...state.single,
        ...(state.single.data ? {
          data: {
            ...state.single.data,
            [_propName]: Array.isArray(state.single.data[_propName]) ? state.single.data[_propName].filter(r => r.Id !== action.data.Id) : null
          }
        } : [])
      };
      return {
        ...state,
        list,
        single
      };
    }
  };
};
var _default = exports.default = joinReducerCases;
module.exports = exports.default;